import get from 'lodash/get'

import { fetchCollection } from './index'

import { technicianWorkSummarySchema } from '../schemas'

export const TECHNICIAN_WORK_SUMMARIES_REQUEST = 'TECHNICIAN_WORK_SUMMARIES_REQUEST'
export const TECHNICIAN_WORK_SUMMARIES_SUCCESS = 'TECHNICIAN_WORK_SUMMARIES_SUCCESS'
export const TECHNICIAN_WORK_SUMMARIES_FAILURE = 'TECHNICIAN_WORK_SUMMARIES_FAILURE'

export function fetchTechnicianWorkSummariesForLocationInContract (locationId, query) {
  return fetchCollection({
    url: `/locations/${locationId}/technician_work_summaries`,
    query,
    key: 'technicianWorkSummaries',
    schema: technicianWorkSummarySchema,
    actions: [
      TECHNICIAN_WORK_SUMMARIES_REQUEST,
      TECHNICIAN_WORK_SUMMARIES_SUCCESS,
      TECHNICIAN_WORK_SUMMARIES_FAILURE
    ],
    responseInterceptor: response => ({ ...response, locationId })
  })
}

export function loadTechnicianWorkSummariesForLocationInContract (locationId) {
  return (dispatch, getState) => {
    let {
      contractId,
      datePeriod: {
        startPeriod,
        endPeriod
      } = {}
    } = get(getState(), `workTrackerFilters.${locationId}`, {})

    if (startPeriod) { startPeriod = startPeriod.toISOString() }
    if (endPeriod) { endPeriod = endPeriod.toISOString() }

    return dispatch(fetchTechnicianWorkSummariesForLocationInContract(locationId, { contractId, startPeriod, endPeriod }))
  }
}



// WEBPACK FOOTER //
// ./src/actions/technician-work-summaries.js